import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/auth.context';
import LoginLoader from './login-loader.component';

const LogoutCallback = () => {
  const { t } = useTranslation();
  const { signoutRedirectCallback } = useAuth();

  useEffect(() => {
    signoutRedirectCallback();
  });

  return <LoginLoader title={t('redirecting-to-login')} />;
};
export default LogoutCallback;
